import type { McpServer } from "@modelcontextprotocol/sdk/server/mcp.js";
import type { Config } from "../../config/schema.js";
import type { ILibraryOperations } from "../../features/operations/library-operations.js";
import { registerAddTool } from "./add.js";
import { registerCheckTool } from "./check.js";
import { registerCiteTool } from "./cite.js";
import {
  registerFulltextAttachTool,
  registerFulltextConvertTool,
  registerFulltextDetachTool,
  registerFulltextDiscoverTool,
  registerFulltextFetchTool,
  registerFulltextGetTool,
} from "./fulltext.js";
import { registerListTool } from "./list.js";
import { registerRemoveTool } from "./remove.js";
import { registerSearchTool } from "./search.js";
import { registerShowTool } from "./show.js";

/**
 * Register all tools with the MCP server.
 *
 * @param server - The MCP server instance
 * @param getLibraryOperations - Function to get the current library operations instance
 * @param getConfig - Function to get the current config (required for fulltext tools)
 */
export function registerAllTools(
  server: McpServer,
  getLibraryOperations: () => ILibraryOperations,
  getConfig: () => Config
): void {
  registerSearchTool(server, getLibraryOperations, getConfig);
  registerListTool(server, getLibraryOperations, getConfig);
  registerCiteTool(server, getLibraryOperations);
  registerCheckTool(server, getLibraryOperations);
  registerAddTool(server, getLibraryOperations);
  registerRemoveTool(server, getLibraryOperations);
  registerShowTool(server, getLibraryOperations, getConfig);
  registerFulltextAttachTool(server, getLibraryOperations, getConfig);
  registerFulltextGetTool(server, getLibraryOperations, getConfig);
  registerFulltextDetachTool(server, getLibraryOperations, getConfig);
  registerFulltextDiscoverTool(server, getLibraryOperations, getConfig);
  registerFulltextFetchTool(server, getLibraryOperations, getConfig);
  registerFulltextConvertTool(server, getLibraryOperations, getConfig);
}
